import { styled } from "@mui/material";
const StyledChip = styled("label")(
  ({ theme, color, disabled, checked }) => ({
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[200],
    display: "flex",
    alignItems: "center",
    gap: "3px",
    padding: "0 9px",
    height: "30px",
    cursor: "pointer",
    boxSizing: "border-box",
    width: "fit-content",
    whiteSpace: "nowrap",
    "@media (hover: hover)": {
      "&:hover": {
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.grey[300]
      }
    },
    "&:has(:focus-visible)": {
      color: theme.palette.grey[600],
      backgroundColor: theme.palette.grey[300]
    },
    "&:active": {
      color: theme.palette.grey[700],
      backgroundColor: theme.palette.grey[300]
    },
    ...disabled && {
      color: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[200]
    },
    ...checked && {
      color: theme.palette.secondary[900],
      backgroundColor: theme.palette.secondary[200],
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.secondary[900],
          backgroundColor: theme.palette.secondary[300]
        }
      },
      "&:has(:focus-visible)": {
        color: theme.palette.secondary[900],
        backgroundColor: theme.palette.secondary[300]
      },
      "&:active": {
        color: theme.palette.secondary[1e3],
        backgroundColor: theme.palette.secondary[400]
      },
      ...disabled && {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[500]
      }
    },
    ...color === "secondary" && {
      border: `2px solid ${theme.palette.grey[500]}`,
      backgroundColor: theme.palette.white.main,
      color: theme.palette.grey[500],
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.grey[600],
          borderColor: theme.palette.grey[600]
        }
      },
      "&:has(:focus-visible)": {
        color: theme.palette.grey[600],
        borderColor: theme.palette.grey[600]
      },
      "&:active": {
        color: theme.palette.grey[700],
        borderColor: theme.palette.grey[700]
      },
      ...disabled && {
        borderColor: theme.palette.grey[400],
        color: theme.palette.grey[400],
        backgroundColor: theme.palette.grey[200]
      },
      ...checked && {
        color: theme.palette.secondary[900],
        borderColor: theme.palette.secondary[900],
        "@media (hover: hover)": {
          "&:hover": {
            color: theme.palette.secondary[800],
            borderColor: theme.palette.secondary[800]
          }
        },
        "&:has(:focus-visible)": {
          color: theme.palette.secondary[800],
          borderColor: theme.palette.secondary[800]
        },
        "&:active": {
          color: theme.palette.secondary[1e3],
          borderColor: theme.palette.secondary[1e3]
        },
        ...disabled && {
          borderColor: theme.palette.grey[500],
          color: theme.palette.grey[500]
        }
      }
    },
    ...disabled && {
      pointerEvents: "none",
      cursor: "default"
    }
  })
), StyledIconContainer = styled("div")(() => ({
  width: "18px",
  height: "18px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
export {
  StyledChip,
  StyledIconContainer
};
//# sourceMappingURL=styles.js.map
